import React from 'react'
import OneColWrapper from '../technical/OneColWrapper'
import Link from '../atoms/Link'

const ButtonsBlock = ({ block }) => {
  return (
    <OneColWrapper block={block}>
      <div className="btn-group" role="group" aria-label="Button group">
        {block.buttons?.length > 0 &&
          block.buttons.map((item, index) => (
            <Link
              link={item.link}
              className={`btn ${index === 0 ? 'btn-primary' : 'btn-secondary'}`}
              key={index}
            >
              <span>
                <i className={`${item.icon?.type} ${item.icon?.icon}`}></i>
                {item.link_text}
              </span>
            </Link>
          ))}
      </div>
    </OneColWrapper>
  )
}

export default ButtonsBlock
